import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { MobileDrawer } from '@/components/layout/MobileDrawer';
import { Sidebar } from '@/components/layout/Sidebar';
import { Topbar } from '@/components/layout/Topbar';

/**
 * Shell for every signed-in view: sidebar on desktop, drawer below lg, and a
 * sticky header. Content scrolls independently of the navigation.
 *
 * The content column shares the public marketing pages' max width
 * (max-w-[1400px]) and padding scale, so moving from the front page to the
 * dashboard doesn't feel like dropping into a different, smaller app.
 */
export function AppLayout() {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-bg">
      <Sidebar />
      <MobileDrawer open={navOpen} onClose={() => setNavOpen(false)} />

      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar onOpenNav={() => setNavOpen(true)} />
        <main id="main" className="min-w-0 flex-1">
          <div className="mx-auto w-full max-w-[1400px] px-4 py-6 sm:px-6 sm:py-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
